import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../../lib/i18next";
import { INPUT_COLOR_BORDER } from "../../../../utils/colors";

const BrandSetupGroupHeader = ({ titleKey, descriptionKey }) => {
  const { t } = useTranslationApp();

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        borderBottom: `1px solid ${INPUT_COLOR_BORDER}`,
        mt: 1,
        py: 2,
        px: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: "text.primary",
          fontSize: "18px",
          lineHeight: "24px",
        }}
      >
        {t(titleKey)}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          display: "block",
          fontSize: "14px",
          lineHeight: "20px",
        }}
      >
        {t(descriptionKey)}
      </Typography>
    </Box>
  );
};

export default BrandSetupGroupHeader;
